import { ImgHTMLAttributes, useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { ensureBlobUrls, selectBlobUrl } from "./attachementsSlice"

type BlobImageProps = Omit<ImgHTMLAttributes<HTMLImageElement>, "src"> & {
    blobId: string
}

/**
 * Renders a blob-backed image through a signed (SAS) read URL minted on demand and
 * cached in the store. Replaces the old synchronous `buildBlobUri` in <img src> sites,
 * which only worked while blob reads were anonymous.
 */
export const BlobImage = ({ blobId, ...imgProps }: BlobImageProps) => {
    const dispatch = useAppDispatch()
    const url = useAppSelector(selectBlobUrl(blobId))

    useEffect(() => {
        if (blobId) {
            dispatch(ensureBlobUrls([blobId]))
        }
    }, [blobId, dispatch])

    // Nothing to show until the URL resolves; the alt text still conveys the image is loading.
    if (!url) {
        return null
    }

    // eslint-disable-next-line jsx-a11y/alt-text
    return <img src={url} {...imgProps} />
}

export default BlobImage
